<template>
  <section>
    <!-- ROUTER HEADER SHOULD GO HERE -->
    <div class="page-banner">
      <div class="container-fluid border-bottom">
        <div class="row align-items-center">
          <div class="col-md-7 p-4 pt-5">
            <h1>
              <img
                src="@/assets/img/_title/23-FCP-consider-your-next-steps.svg"
                class="img-fluid"
                alt="Assess your employability skills"
                srcset=""
              >
            </h1>
          </div>
        </div>
      </div>
    </div>

    <!-- ROUTER CONTENT GOES HERE -->

    <!-- TEXT CONTENT -->
    <content-block class="bg-light-grey">
      <div class="row">
        <div class="col-md-8 p-4">
          <p>Reflect on your on-campus work experience and think about how your goals might have changed since the beginning of your employment. You might have new questions such as… </p>
          <ul>
            <li>Should I consider a career change? </li>
            <li>Where can I learn more about a different career path?</li>
            <li>Would a mentoring relationship be right for me?</li>
            <li>How can I maintain relationships with my supervisor and colleagues?</li>
            <li>What other opportunities can I pursue?</li>
          </ul>
          <p>Book an appointment with an Employment Advisor or Career Counsellor at the Career Services department to get more guidance and support.</p>
        </div>
        <div class="col-md bg-img bg-img--future-career-23">
          <!-- <img
            src="@/assets/img/_content/template-placeholder-01.jpg"
            alt=""
            class="img-fluid content-block__img"
          > -->
        </div>
      </div>
    </content-block>
  </section>
</template>

<script>
import ContentBlock from '@/components/ContentBlock.vue'
// import Accordion from '@/components/Accordion.vue'
// import SidebarMenu from '../components/SidebarMenu.vue'
// import {
//   Hooper,
//   Slide,
//   Navigation as HooperNavigation,
//   Pagination as HooperPagination
// } from 'hooper'
// import 'hooper/dist/hooper.css'

export default {
  name: '01',
  components: {
    ContentBlock
    // SidebarMenu,
    // Accordion
    // Hooper,
    // Slide,
    // HooperNavigation,
    // HooperPagination
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },

  mounted () {
  }
}
</script>

<style>
</style>
